module.exports = __webpack_public_path__ + "static/media/WhiteSands.fed1f76f.jpg";